var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FieldParameterTracks_graph, _FieldParameterTracks_field, _FieldParameterTracks_regionNotifier, _FieldParameterTracks_collection, _FieldParameterTracks_subscriptions, _FieldParameterTracks_subscription;
import { Notifier, Option, panic, UUID } from "@opendaw/lib-std";
import { Pointers } from "@opendaw/studio-enums";
import { TrackBox } from "@opendaw/studio-boxes";
import { IndexedBoxAdapterCollection } from "../IndexedBoxAdapterCollection";
import { TrackBoxAdapter } from "./TrackBoxAdapter";
export class FieldParameterTracks {
    constructor(graph, field, boxAdapters) {
        _FieldParameterTracks_graph.set(this, void 0);
        _FieldParameterTracks_field.set(this, void 0);
        _FieldParameterTracks_regionNotifier.set(this, new Notifier());
        _FieldParameterTracks_collection.set(this, void 0);
        _FieldParameterTracks_subscriptions.set(this, void 0);
        _FieldParameterTracks_subscription.set(this, void 0);
        __classPrivateFieldSet(this, _FieldParameterTracks_graph, graph, "f");
        __classPrivateFieldSet(this, _FieldParameterTracks_field, field, "f");
        __classPrivateFieldSet(this, _FieldParameterTracks_collection, IndexedBoxAdapterCollection.create(field, box => boxAdapters.adapterFor(box, TrackBoxAdapter), Pointers.TrackCollection), "f");
        __classPrivateFieldSet(this, _FieldParameterTracks_subscriptions, UUID.newSet(({ uuid }) => uuid), "f");
        __classPrivateFieldSet(this, _FieldParameterTracks_subscription, __classPrivateFieldGet(this, _FieldParameterTracks_collection, "f").catchupAndSubscribe({
            onAdd: (adapter) => __classPrivateFieldGet(this, _FieldParameterTracks_subscriptions, "f").add({
                uuid: adapter.uuid,
                subscription: adapter.regions.subscribeChanges(() => __classPrivateFieldGet(this, _FieldParameterTracks_regionNotifier, "f").notify())
            }),
            onRemove: ({ uuid }) => __classPrivateFieldGet(this, _FieldParameterTracks_subscriptions, "f").removeByKey(uuid).subscription.terminate(),
            onReorder: (_adapter) => { }
        }), "f");
    }
    create(type, target, index) {
        return TrackBox.create(__classPrivateFieldGet(this, _FieldParameterTracks_graph, "f"), UUID.generate(), box => {
            box.index.setValue(index ?? __classPrivateFieldGet(this, _FieldParameterTracks_collection, "f").getMinFreeIndex());
            box.type.setValue(type);
            box.tracks.refer(__classPrivateFieldGet(this, _FieldParameterTracks_field, "f"));
            box.target.refer(target);
        });
    }
    controls(target) {
        return Option.wrap(__classPrivateFieldGet(this, _FieldParameterTracks_collection, "f").adapters()
            .find(adapter => adapter.target.targetVertex.contains(target), false));
    }
    delete(adapter) {
        const adapters = __classPrivateFieldGet(this, _FieldParameterTracks_collection, "f").adapters();
        const deleteIndex = adapters.indexOf(adapter);
        if (deleteIndex === -1) {
            return panic(`Cannot delete ${adapter}. Does not exist.`);
        }
        for (let index = deleteIndex + 1; index < adapters.length; index++) {
            adapters[index].indexField.setValue(index - 1);
        }
        adapter.box.delete();
    }
    get collection() { return __classPrivateFieldGet(this, _FieldParameterTracks_collection, "f"); }
    values() { return __classPrivateFieldGet(this, _FieldParameterTracks_collection, "f").adapters(); }
    catchupAndSubscribe(listener) {
        return __classPrivateFieldGet(this, _FieldParameterTracks_collection, "f").catchupAndSubscribe(listener);
    }
    subscribeAnyChange(observer) { return __classPrivateFieldGet(this, _FieldParameterTracks_regionNotifier, "f").subscribe(observer); }
    terminate() {
        __classPrivateFieldGet(this, _FieldParameterTracks_collection, "f").terminate();
        __classPrivateFieldGet(this, _FieldParameterTracks_subscription, "f").terminate();
        __classPrivateFieldGet(this, _FieldParameterTracks_subscriptions, "f").forEach(({ subscription }) => subscription.terminate());
        __classPrivateFieldGet(this, _FieldParameterTracks_subscriptions, "f").clear();
    }
}
_FieldParameterTracks_graph = new WeakMap(), _FieldParameterTracks_field = new WeakMap(), _FieldParameterTracks_regionNotifier = new WeakMap(), _FieldParameterTracks_collection = new WeakMap(), _FieldParameterTracks_subscriptions = new WeakMap(), _FieldParameterTracks_subscription = new WeakMap();
